export const CandidateHelpModalContent = {
  acic_check: (t, options = {}) => ({
    description: {
      content: [
        t('check.backgroundChecks.acic_check.stepOne'),
        t('check.backgroundChecks.acic_check.stepTwo'),
        t('check.backgroundChecks.acic_check.stepThree', {
          companyName: options.companyName ?? 'Company',
        }),
        t('check.backgroundChecks.acic_check.stepFour'),
      ],
    },
  }),
};
